
export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-blue-900 mb-4">会社概要</h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-8">
            <div className="bg-white p-8 rounded-lg shadow-md border border-blue-100">
              <h3 className="text-2xl font-bold text-blue-900 mb-6">企業情報</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-24 text-blue-600 font-medium">会社名</div>
                  <div className="flex-1 text-blue-900">中山キャピタル株式会社</div>
                </div>
                <div className="flex items-start">
                  <div className="w-24 text-blue-600 font-medium">代表者</div>
                  <div className="flex-1 text-blue-900">代表取締役 中山 智史</div>
                </div>
                <div className="flex items-start">
                  <div className="w-24 text-blue-600 font-medium">所在地</div>
                  <div className="flex-1 text-blue-900">
                    <div className="font-medium mb-1">大阪オフィス</div>
                    <div>〒532-0011 大阪府大阪市淀川区西中島4丁目2番21号 3F</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-md border border-blue-100">
              <h4 className="text-xl font-bold text-blue-900 mb-4">事業方針</h4>
              <p className="text-blue-800 leading-relaxed">
                実業に根ざした成長の仕組みを創る「仕組みのデザイナー」として、
                個人・法人の長期的な発展を支援いたします。資産創造の仕組みを日本から世界に発信することを目指しております。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
